import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-docs',
  imports: [RouterModule],
  templateUrl: './docs.component.html',
  styleUrl: './docs.component.css',
})
export class DocsComponent {
  sections = [
    { id: 'intro', title: 'Introduction', content: 'Predivent est une application SaaS d\'aide à la décision pour les marchands.' },
    { id: 'events', title: 'Gestion des événements', content: 'Créez et gérez vos événements (marchés, foires, salons) depuis l\'onglet Événements.' },
    { id: 'products', title: 'Catalogue produits', content: 'Importez ou créez manuellement votre catalogue de produits avec prix et unités.' },
    { id: 'recommendations', title: 'Recommandations', content: 'L\'algorithme génère des recommandations de quantités basées sur vos historiques.' },
    { id: 'api', title: 'API REST', content: 'Documentation de l\'API REST disponible sur demande pour les intégrations personnalisées.' },
  ];
}